
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advantages/[id]",
      function () {
        return require("private-next-pages/advantages/[id]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/advantages/[id]"])
      });
    }
  